import styled from "styled-components";
import download_orange_icon from "../../../images/download_orange_icon.png";
import play_Icon from "../../../images/play_button.svg";

export const SponsorChildCard=styled.div`
    height: 133px;
    flex-shrink: 0;
    border-radius: 12px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
    background-color: #fff;
    cursor: pointer;
    margin-bottom: 21px;
    margin-right: 1.3%;
    width: 43% !important;
    @media only screen and (max-width: 850px){
        width: 100% !important;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        margin: 2% 1.5%;
        width: 47% !important;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        margin: 2% 1.5%;
        width: 47% !important;
    }
    @media only screen and (min-width: 1200px) and (max-width:1400px) {
        padding-right:1rem;
    }
`
export const IncreaseImpactWrapper = styled.div`
    z-index:0;
    width:100%;
    max-width:85%;
    border-radius:8px;
    box-shadow: 2px 4px 15px rgba(0, 0, 0, 0.25);
    margin:5% auto 10% auto;
    background: #FFFFFF;
    & img{
        position: relative;
        width:100%;
        height:100px;
        object-fit:cover;
        object-position: 0 15%;
        justify-content: center;
        align-items: center;
        border-radius:8px 8px 0 0;
        @media screen and (min-width: 1600px) and (max-width:1920px) {
            {
                height:130px;
            }
        } 
    }
    & div{
        margin:2%;
        margin-bottom:10px;
        color: var(--wv-tints-shades-grey-3, #333);
        font-family: Lato;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
        text-align: center;
        vertical-align: middle;
    }
   
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        min-width: 230px;
        margin: 2% 2% 2% 1%;
        & img{
            //height:220px;
        }
        & div{
            height:max-content;
        }
    }
`;
export const IncreaseImpactDiv = styled.div`
    padding:2%;
    min-height: 100px;
`;
export const VisitWebSiteImpactWrapper = styled.div`
    z-index:0;
    width:100%;
    max-width:85%;
    border-radius:8px;
    box-shadow: 2px 4px 15px rgba(0, 0, 0, 0.25);
    margin:2% auto 10%;
    background: #FFFFFF;
    & img{
        position: relative;
        width:100%;
        height:100px;
        object-fit:cover;
        object-position: 0 15%;
        justify-content: center;
        align-items: center;
        border-radius:8px 8px 0 0;
        @media screen and (min-width: 1200px) and (max-width:1400px) {
            {
                object-position: 0 0%;
            }
        } 
        @media screen and (min-width: 1400px) and (max-width:1600px) {
            {
                object-position: 0 1%;
            }
        } 
        @media screen and (min-width: 1600px) and (max-width:1920px) {
            {
                object-position: 0 3%;
                height:130px;
            }
        } 
    }
    & div{
        margin:2%;
        margin-bottom:10px;
        color: var(--wv-tints-shades-grey-3, #333);
        font-family: Lato;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
        text-align: center;
        vertical-align: middle;
    }
   
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        min-width: 230px;
        margin: 2% 2%;
        & img{
            //height:220px;
        }
        & div{
            height:max-content;
        }
    }
   
`;

export const ReferFriendsWrapper = styled(IncreaseImpactWrapper)`
    margin:2% auto 10% auto;
    background: #FFFFFF;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        min-width: 230px;
        margin: 2%;
        & img{
            //height:220px;
        }
        & div{
            height:max-content;
        }
    }
`;

export const Statement = styled.div`
    position: relative;
    height:7.8vh;
    width:67vw;
    top:-1vh;
    left:3vh;
    border-radius: 12px;
    border: 1px solid #E6E6E6;
    background: #FFF;
    align-items: center;
    display: flex;
    margin-bottom: 8px;
    & img{
        position: relative;
        width:3.1vh;
        height:3.1vh;
        left: 1.3vw;
    }
    & span{
        position: relative; 
        left: 4.6vw;
        color: #666;
        font-family: Lato;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%;
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
    }
    & button{
        position: relative;
        background: url(${download_orange_icon}) 0 0;
        background-size: contain;
        object-fit: cover;
        width: 2.3vh;
        height: 2.8vh;
        left:100vh;
        @media only screen and (min-width: 750px) and (max-width: 1180px){
            left: 53%
          }
    }
`;

export const VideoCard = styled.button`
    position: relative;
    right: 27%;
    top: 10vh;
    width: 14%;
    height: 60px;
    background: url(${play_Icon}) 0 0 no-repeat;
    transform: translate(-50%, -50%);
    @media only screen and (max-width: 1400px){
        top: 14vh;
    }
    @media only screen and (max-width: 600px){
        top:-13vh;
        right: 0%;
    }
    @media only screen and (min-width: 601px) and (max-width: 850px){
        top:-11vh;
        right: -10%;
    }
`;

export const ConnectVideoCard = styled.div`
    position: relative;
    width: 100%;
    height: 27.75vh;
    border-radius: 0px;
    border: none;
    background:#000 0;
    margin: 0 8% 0 10%;
    cursor:pointer;
    background-size:cover;
    background-repeat:no-repeat;

    & img {
        width:100%;
    }
    @media only screen and (max-width: 600px){
        width: 90%;
        margin: 0 0 3% 0;
        //max-height: 235px;
    }
    @media only screen and (min-width: 601px) and (max-width: 749px){
        margin:auto;
        width: 50vh;
        min-height: 235px;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait)
    {
        width: 100%;
    }
`;

export const DonationStat = styled.div`
    position: relative;
    height:7.8vh;
    width:67vw;
    top:-1vh;
    left:3vh;
    border-radius: 12px;
    border: 1px solid #E6E6E6;
    background: #FFF;
    align-items: center;
    display: flex;
    margin-bottom: 8px;
    flex-direction:row;
    justify-content: space-between;
    padding:1.3vw;
    & span{
        position: relative; 
        color: #666;
        font-family: Lato;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%;
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
    }
`;


 export const MarkerContainer = styled.div`
 `
 export const SponsorContainer = styled.div`
        cursor: pointer;
 `
